import React from 'react';
import PropTypes from 'prop-types';

class DownloadTool extends React.PureComponent {
  static onClickHelper() {
    let shareKey = null;
    if (window.DocumentSettings && window.DocumentSettings.shareKey) {
      shareKey = window.DocumentSettings.shareKey;
    }
    window.ExportDocument.processExport(shareKey);
  }

  constructor() {
    super();

    this.exportToolDownloadOnClick = this.exportToolDownloadOnClick.bind(this);
    this.getDownloadToolButton = this.getDownloadToolButton.bind(this);
    this.pdfOnClick = this.pdfOnClick.bind(this);
    this.trackExport = this.trackExport.bind(this);
    this.wordOnClick = this.wordOnClick.bind(this);
  }

  getDownloadToolButton() {
    const createButton = (id, key, onclick, className, text, extraEl) => {
      const rKey = key || id;
      return (
        <button
          id={id}
          key={rKey}
          onClick={onclick}
          className={className}
        >
          {extraEl}
          {text}
        </button>);
    };

    let button;
    if (this.props.showConvertDoc) {
      button = createButton('convert_tool', 'convert_tool', () => {
        window.ExportDocument.exportDocx();
      }, 'btn btn-success', 'Convert to Word Document');
    } else {
      button = createButton('export_tool', 'export_tool', this.exportToolDownloadOnClick,
      'btn btn-success', ` Download ${this.props.documentLabel}`,
        <i className="icon-white icon-download-alt" />);
    }

    return button;
  }

  exportToolDownloadOnClick() {
    if (this.props.disabled) {
      return;
    }
    DownloadTool.onClickHelper();
    if (this.props.trackingContext === 'Freewrite') {
      window._track('Downloaded PDF', `${this.props.documentLabel}`);
    } else {
      window._track('Downloaded Template', `${this.props.documentLabel}`);
    }
    this.trackExport('PDF');
  }

  pdfOnClick() {
    if (this.props.disabled) {
      return;
    }
    DownloadTool.onClickHelper();
    this.trackExport('PDF');
  }

  trackExport(type) {
    if (this.props.trackingContext === 'Freewrite') {
      window._track(`Freewrite Export - ${type} | ${this.props.memberTracking ? 'Member' : 'Non-Member'}`, `${this.props.documentType}`);
    } else {
      window._track(`Download ${type} | ${this.props.trackingContext}`, this.props.trackingContext);
    }
  }

  wordOnClick() {
    if (this.props.disabled) {
      return;
    }
    window.ExportDocument.exportDocx();
    this.trackExport('Word');
  }


  render() {
    return (
      <div className="btn-group">
        {this.getDownloadToolButton()}
        <a
          id="exportToggle"
          key="exportToggle"
          className="btn btn-success dropdown-toggle"
          data-toggle="dropdown"
          href=""
        >
          <span className="caret" />
        </a>
        <ul key="dropdown-menu-ul" className="dropdown-menu dropdown-menu-right pull-right">
          <li>
            <button className="btn btn-link" onClick={this.pdfOnClick} id="export_tool">
              <i className="icon-download" />
              &nbsp;Download as PDF (.pdf)
            </button>
          </li>
          <li>
            <button className="btn btn-link" onClick={this.wordOnClick} id="export_to_docx">
              <i className="icon-pencil" />
              &nbsp;Download as Word (.docx)
            </button>
          </li>
        </ul>
      </div>
    );
  }
}

DownloadTool.defaultProps = {
  disabled: false,
  documentLabel: 'My PDF',
  documentType: '',
  memberTracking: '',
  showConvertDoc: false,
  trackingContext: 'Freewrite',
};

DownloadTool.propTypes = {
  disabled: PropTypes.bool,
  documentLabel: PropTypes.string,
  documentType: PropTypes.string,
  memberTracking: PropTypes.string,
  showConvertDoc: PropTypes.bool,
  trackingContext: PropTypes.string,
};

export default DownloadTool;



// WEBPACK FOOTER //
// ./src-react/ExportToolbar/DownloadTool.jsx